export const ADD_SINGLE_USER_HEADER = 'Add Single User'
export const ADD_MULTIPLE_USERS_HEADER = 'Add Multiple Users'
export const BULK_USERS_INFO_TEXT = 'Max 200 emails per bulk upload'
export const SINGLE_EMAIL_LABEL = 'Email address'
export const BULK_EMAIL_LABEL = 'Email addresses'
export const EMAIL_INPUT_PLACEHOLDER =
  'Enter emails separated by commas, semicolons, or new lines'
